// Branded placeholder art for masjids without an uploaded photo.
// Deterministic: the slug always hashes to the same variant.

const VARIANTS = ['emerald', 'gold', 'navy', 'teal', 'sand', 'midnight'] as const

export function masjidPlaceholder(slug: string | null | undefined): string {
  const s = slug || 'masjid'
  let h = 0
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0
  return `/placeholders/masjid-${VARIANTS[h % VARIANTS.length]}.svg`
}
